<template>
    <div id="mediahero">
      <div><h1> Soft Skills Academy 6 </h1></div>
      <Countdown ext_date="2020-08-31T20:59:59Z" class="countdown"/>
      <img class="path" :src="path" />
      <div class="rules"> Regulament </div>
  </div>
</template>

<script>
import Countdown from "@/components/widgets/RegisterCountdown.vue";
export default {
  components: {
    Countdown
  },
  data() {
    return {
      path: require("@/assets/images/HomeHeroPath.svg")
    }
  }
};
</script>

<style scoped lang="scss">
#mediahero {
  width: 100%;
  height: $video-hero-height;
  height: 100vh;
  overflow: hidden;
  background-image: url('../../assets/images/imagine-fundal-min.png');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10vh;
}

h1 {
  margin-top: 1%;
  text-align: center;
  font-family: "Acumin Variable Concept";
  word-spacing: 0.3vh;
  font-weight: 500;
  font-size: 4vw;
  color: #edf6fb;
}

.path {
  position: absolute;
  width: 100vw;
  height: auto;
  bottom: -1.5vh;
}

.rules {
  display: inline-block;
  margin-left: 20vw;
  margin-top: 30vh;
  z-index: 100;
  font-family: "Acumin Variable Concept";
  font-size: 2.5vw;
  font-weight: 600;
  color: #edf6fb;
}

@media (max-width: 1024px) and (max-height: 850px){
  #mediahero {
    height: 50vw;
  }

  h1 {
    font-size: 12vw;
    margin-bottom: 4.75vh;
    margin-top: 24vh;
  }

  .rules {
    visibility: hidden;
  }
}


@media screen and (max-width: 1024px){
  #mediahero {
    height: 45vh;
  }

  h1 {
    font-size: 7vw;
    margin-bottom: 0vh!important;
    margin-top: 20vh;
  }

  .rules {
    visibility: hidden;
  }

  .countdown {
    transform: scale(1.25,1.25);
    margin-bottom: 0;  
  }

}


</style>




